var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 23C3.24 23 1 20.64 1 17.74V10.01C1 8.58 1.68 7.26 2.81 6.48L9.78 1.69C10.43 1.24 11.19 1 11.97 1C12.75 1 13.51 1.24 14.16 1.69L21.12 6.49C22.25 7.27 22.93 8.59 22.93 10.02V17.75C22.93 20.65 20.69 23.01 17.93 23.01H6V23Z",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.96 2C12.54 2 13.1 2.18 13.58 2.51L20.54 7.31C21.4 7.91 21.92 8.92 21.92 10.02V17.75C21.92 20.1 20.13 22.01 17.92 22.01H6C3.79 22.01 2 20.1 2 17.75V10.02C2 8.92 2.52 7.91 3.38 7.31L10.34 2.51C10.82 2.18 11.39 2 11.96 2ZM11.96 0C11 0 10.04 0.29 9.21 0.86L2.25 5.66C0.84 6.62 0 8.26 0 10.01V17.74C0 21.2 2.69 24 6 24H17.93C21.24 24 23.93 21.2 23.93 17.74V10.01C23.93 8.26 23.09 6.62 21.68 5.66L14.72 0.86C13.88 0.29 12.92 0 11.96 0Z",
    fill: "#FF3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3601 15.38C14.4701 14.43 13.0001 12.78 11.4901 13.21C11.2601 13.27 11.0501 13.38 10.8501 13.5C10.0101 13.98 9.3001 14.68 8.6501 15.38C8.3001 15.75 7.9301 16.05 7.7201 16.54C7.4201 17.25 7.6901 18.13 8.2801 18.61C8.8701 19.09 9.6501 19.15 10.3701 18.97C11.0101 18.68 11.7201 18.53 12.4201 18.62C12.8601 18.67 13.2401 18.87 13.6601 18.97C14.2501 19.12 14.9201 19.13 15.4501 18.79C15.9201 18.49 16.3201 18 16.4201 17.44C16.4801 17.08 16.3901 16.72 16.2301 16.4C16.0101 15.98 15.6801 15.71 15.3701 15.37L15.3601 15.38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71725 14.7333C8.43912 14.6315 8.90986 13.7376 8.76868 12.7369C8.62749 11.7361 7.92785 11.0073 7.20598 11.1092C6.48412 11.211 6.01338 12.1049 6.15456 13.1056C6.29575 14.1064 6.99539 14.8351 7.71725 14.7333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1499 12.4601C10.9673 12.4601 11.6299 11.5602 11.6299 10.4501C11.6299 9.33997 10.9673 8.44006 10.1499 8.44006C9.33254 8.44006 8.66992 9.33997 8.66992 10.4501C8.66992 11.5602 9.33254 12.4601 10.1499 12.4601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2747 10.5252C15.3268 9.41631 14.7071 8.48629 13.8907 8.44793C13.0742 8.40957 12.3701 9.27739 12.318 10.3863C12.2659 11.4951 12.8855 12.4251 13.702 12.4635C14.5185 12.5019 15.2226 11.634 15.2747 10.5252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8318 13.2309C18.068 12.2767 17.6945 11.3633 16.9975 11.1908C16.3006 11.0183 15.5441 11.6521 15.308 12.6064C15.0718 13.5606 15.4454 14.474 16.1423 14.6465C16.8392 14.819 17.5957 14.1852 17.8318 13.2309Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeFill);
export default __webpack_public_path__ + "static/media/icon-home-fill.7dee17f24d1cf6a535968a926c475dcf.svg";
export { ForwardRef as ReactComponent };